export const candidateEndpoints = {
  candidateJobs: '/jobs/{jobId}/candidates',
  candidateJobCounts: '/jobs/{jobId}/candidates/counts',
  candidateJob: '/jobs/{jobId}/candidates/{candidateId}',
  prescreenLink: '/jobs/{jobId}/candidates/{candidateId}/prescreen',
  prescreenCandidate: '/jobs/{jobId}/candidates/{candidateId}/prescreened',
  assessment: '/jobs/{jobId}/candidates/{candidateId}/assessment',

  shortlistCandidates: '/jobs/{jobId}/candidates/shortlist',
  enrichCandidates: '/jobs/{jobId}/candidates/enrich',
  prescreenCandidates: '/jobs/{jobId}/candidates/prescreened',
  declineCandidates: '/jobs/{jobId}/candidates/decline',
  rejectCandidates: '/jobs/{jobId}/candidates/reject',
  rejectionMessages: '/jobs/{jobId}/candidates/rejection-messages',
  approvalMessage: '/jobs/{jobId}/candidates/{candidateId}/approval-message',
  approveCandidate: '/jobs/{jobId}/candidates/{candidateId}/approve',
  reachoutCandidates: '/jobs/{jobId}/candidates/reachout',
  interviewCandidates: '/jobs/{jobId}/candidates/interview',

  candidateFeedback: '/jobs/{jobId}/candidates/{candidateId}/feedback',
  bulkCandidateFeedback: '/jobs/{jobId}/candidates/feedbacks',

  candidateJobHiringStatus:
    '/jobs/{jobId}/candidates/{candidateId}/hiring-status',

  candidateJobNotes: '/candidate-jobs/{candidateJobId}/notes',
  candidateJobNote: '/candidate-jobs/{candidateJobId}/notes/{noteId}',
} as const;
